import { HOUSING } from "@/data";
import { ArrowRight } from "lucide-react";

export const Housing = () => {
  return (
    <section id="housing" className="bg-[#0F0F0F] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#FFC000]">Housing Options</span>
            <h2 className="mt-3 font-heading font-black tracking-tight text-3xl md:text-4xl leading-tight">
              Comfortable homes for every stage of the journey
            </h2>
          </div>
          <p className="text-white/70 max-w-sm md:text-right">
            From shared community living to private transitional apartments — find the space that fits your path.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {HOUSING.map((h) => (
            <div
              key={h.title}
              data-testid={`housing-${h.title.toLowerCase().replace(/\s/g, "-")}`}
              className="group bg-white text-[#0F0F0F] border-2 border-white/20 overflow-hidden hover:border-[#FFC000] transition-colors"
            >
              <div className="relative overflow-hidden">
                <img src={h.img} alt={h.title} className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 bg-[#FFC000] text-[#0F0F0F] text-xs font-bold uppercase tracking-wide px-3 py-1 border-2 border-[#0F0F0F]">{h.tag}</span>
              </div>
              <div className="p-6">
                <h3 className="font-heading font-bold text-xl">{h.title}</h3>
                <p className="mt-2 text-sm text-[#4A4A4A] leading-relaxed">{h.desc}</p>
                <a href="#apply" className="mt-4 inline-flex items-center gap-1 font-bold text-sm text-[#0F0F0F] hover:gap-2 transition-all">
                  Inquire about this option <ArrowRight size={15} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
